import { isEmpty, isUndefined } from 'lodash';

import { COLOUR_DATA } from 'commons-vehicle/constants/dataConversions.js';
import Colour from 'commons-vehicle/ModelYear/models/ColourModel.js';
/* eslint import/prefer-default-export: 0 */

export function resetColourFromConfigurationData(configurationColourData, features) {
    if (isEmpty(configurationColourData) || configurationColourData.length <= COLOUR_DATA.PRICING) {
        return new Colour();
    }

    let retail = 0;
    let residualRetail = 0;
    if (
        !isEmpty(configurationColourData[COLOUR_DATA.PRICING]) &&
        configurationColourData[COLOUR_DATA.PRICING].length === 2
    ) {
        const configurationTrimPricing = configurationColourData[COLOUR_DATA.PRICING];

        retail = configurationTrimPricing[COLOUR_DATA.AMOUNTS.RETAIL];
        residualRetail = configurationTrimPricing[COLOUR_DATA.AMOUNTS.RESIDUAL_RETAIL];
    }

    const colourCode = configurationColourData[COLOUR_DATA.CODE];
    const colourDescription =
        isUndefined(features) || isEmpty(features) || isEmpty(features[colourCode])
            ? ''
            : features[colourCode].description;

    let fabricDescription = '';
    let seatColourDescription = '';
    if (!isEmpty(features) && !isEmpty(features[colourCode]) && !isEmpty(features[colourCode].colourFeatures)) {
        fabricDescription = features[colourCode].colourFeatures[COLOUR_DATA.FEATURE_FABRIC] || '';
        seatColourDescription =
            features[colourCode].colourFeatures[COLOUR_DATA.FEATURE_SEAT] ||
            features[colourCode].colourFeatures[COLOUR_DATA.FEATURE_INTERIOR] ||
            '';
    }

    return new Colour({
        colourCode,
        colourDescription: seatColourDescription || colourDescription,
        fabricDescription,
        selected: false,
        enabled: true,
        visible: true,
        colourTile: configurationColourData[COLOUR_DATA.TILE],
        photo1: configurationColourData[COLOUR_DATA.PHOTO_1],
        photo2: configurationColourData[COLOUR_DATA.PHOTO_2],
        photo3: configurationColourData[COLOUR_DATA.PHOTO_3],
        retail,
        residualRetail,
    });
}

export default {
    resetColourFromConfigurationData,
};
